import { ReactNode } from 'react';
import styled from 'styled-components';

import { borderGradientStyle } from 'style/utils';

const TextContainer = styled.div`
  pointer-events: none;
  width: fit-content;
  padding: var(--unit) var(--intermediate-unit);
  border-radius: var(--half-unit);
  background-color: var(--c-black);
  --border-gradient: linear-gradient(
    to bottom right,
    #c5f3d7 0%,
    #96e8fe 10%,
    #fa8dfa 20%,
    #938afd 30%,
    #be6bfb 40%,
    #c5f3d7 50%,
    #96e8fe 60%,
    #fa8dfa 70%,
    #938afd 80%,
    #be6bfb 90%
  );
  --border-size: 2px;
  ${borderGradientStyle};
  box-shadow:
    0 0 4px 0 var(--c-black),
    0 0 8px 0 var(--c-black);
`;

const OuterContainer = styled.div`
  pointer-events: none;
  padding: var(--half-unit);
  border-radius: var(--half-unit);
  transform: skew(-10deg);
  background: linear-gradient(
    to bottom right,
    #c5f3d7 0%,
    #96e8fe 10%,
    #fa8dfa 20%,
    #938afd 30%,
    #be6bfb 40%,
    #c5f3d7 50%,
    #96e8fe 60%,
    #fa8dfa 70%,
    #938afd 80%,
    #be6bfb 90%
  );
`;

const ChildrenContainer = styled.div`
  transform: skew(10deg);
`;

type Props = {
  children: ReactNode;
};

export const RhomboidRainbowContainer = ({ children }: Props) => {
  return (
    <OuterContainer>
      <TextContainer>
        <ChildrenContainer>{children}</ChildrenContainer>
      </TextContainer>
    </OuterContainer>
  );
};
